// Module
var code = `<textarea readonly="readonly" class="width_full" data-bind="click: showCryotankPicker,
                     value: ko.unwrap(disable) ? undefined : cryotankPath().length ? cryotankPath().join(' > ') : translated('Click to select'),
                     css: {invalid_data: cryotankPath.isInvalid},
                     attr: {id: htmlId},
                     disable: disable"></textarea>
`;
// Exports
export default code;